import StoreUtil from '@/store/StoreUtil'

export default {
  FETCH_SCAN_RESULT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'fetchScanResult'
  ),
  UPDATE_STARRED: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'updateStarred'
  ),
  UPDATE_TITLE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'updateTitle'
  ),
  FETCH_POWER_EDIT_DATA: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'fetchPowerEditData'
  ),
}
